(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-collection-template-prime"]) return;
  try {
    
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function (e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-template"]) return;
  try {
    
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function (e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-you-may-also-like"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        $(document).ready(function () {
          const youMayAlsoLikePs = $('.you_may_also_like_product_review_summary');
          console.log(youMayAlsoLikePs.length);

          for (let i = 0; i < youMayAlsoLikePs.length; i++) {
            const youMayAlsoLikeP = youMayAlsoLikePs[i];
            console.log(youMayAlsoLikeP);
            //const productLink = youMayAlsoLikeP.parent("div").children("a");
            //.find("a").attr("href");

            console.log('Test');
            //console.log(productLink)
          }

          $('.you_may_also_like_section_wrapper_slider').slick({
            slidesToShow: 3,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
              {
                breakpoint: 968,
                settings: {
                  infinite: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  zIndex: 1,
                  slidesToShow: 2,
                  arrows: false,
                },
              },
              {
                breakpoint: 670,
                settings: {
                  infinite: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  zIndex: 1,
                  slidesToShow: 1,
                  arrows: false,
                },
              },
            ],
          });
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
